export class CreateOAuthAppRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "type",
            "baseName": "type",
            "type": "CreateOAuthAppRequestTypeEnum",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return CreateOAuthAppRequest.attributeTypeMap;
    }
    constructor() {
    }
}
export var CreateOAuthAppRequestTypeEnum;
(function (CreateOAuthAppRequestTypeEnum) {
    CreateOAuthAppRequestTypeEnum["GcpGemini"] = "gcp-gemini";
})(CreateOAuthAppRequestTypeEnum || (CreateOAuthAppRequestTypeEnum = {}));
